import BaseModelAPI from '../BaseModelAPI';

export default class BillOfMaterialList extends BaseModelAPI {

	static entity = 'billofmateriallist'
	static entityName = 'billofmaterial';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
